import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../../../http-error-handler.service';
import { EndpointLocationProviderService } from '../../../shared/services/endpoint-location-provider.service';

@Injectable({
    providedIn: 'root'
})
export class ProdutoCatalogoService {

    private env = environment;
    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('ProdutoCatalogoService');
    }

    getListTipoEmissao(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PRODUTO)}/api/GetListTipoEmissao`)
            .pipe(
                catchError(this.handleError('Buscar o tipo de emissão dos produtos.', []))
            );
    }

    getListProducts(idTipoEmissao, idCatalogo): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PRODUTOS_CATALOGO)}/api/CatalogoProduto/GetListProdutoByCatalogo/${idTipoEmissao}/${idCatalogo}`)
            .pipe(
                catchError(this.handleError('Buscar os produtos do filtro', []))
            );
    }

    getList(idCatalogo): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PRODUTOS_CATALOGO)}/api/CatalogoProduto/GetList/`, { idCatalogo })
            .pipe(
                catchError(this.handleError('Buscar lista de produtos', []))
            );
    }

    add(produtosCatalogo): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PRODUTOS_CATALOGO)}/api/CatalogoProduto/Add/`, JSON.stringify(produtosCatalogo))
            .pipe(
                catchError(this.handleError('Salvar produtos', []))
            );
    }
}
